import { defaultGrid } from "../../helpers/datagrid";
import { initialState } from "../reducers/organisationDirectoryReducer";

export const emptyTransactionsSection = (clearFilters = true) => async dispatch => {
	dispatch({type: 'FETCH_TRANSACTIONS', payload: defaultGrid });
	if (clearFilters) dispatch({type: 'FETCH_TRANSACTIONS_FILTERS', payload: {...initialState}});
}

export const setTransactionsKiosk = (payload) => async dispatch => {
	dispatch({type: 'TRANSACTIONS_KIOSK', payload });
}

